import { defineStore } from 'pinia'

export const useSessionStore = defineStore('session', {
  state: () => ({
    gender: null,
    selfiePhoto: null,
    quizAnswers: [],
    personaId: null,
    generatedPhoto: null,
    generatedVideo: null,
    photoJobId: null,
    videoJobId: null,
    sessionId: null,
  }),

  actions: {
    reset() {
      this.gender = null
      this.selfiePhoto = null
      this.quizAnswers = []
      this.personaId = null
      this.generatedPhoto = null
      this.generatedVideo = null
      this.photoJobId = null
      this.videoJobId = null
      this.sessionId = null
    },
    startSession() {
      this.sessionId = Date.now().toString(36)
    },
  },
})
